import { FC } from 'react';

import cx from 'classnames';
import { isNil, prop } from 'ramda';

import Icon from '../Icon';
import s from './index.module.css';
import { IEditorBlockBarProps } from './types';

const EditorBlockBar: FC<IEditorBlockBarProps> = ({
  items,
  className: blockClassName,
  lowerPosition,
  classNameWrapper,
}) => {
  return (
    <div className={cx(s.blockWrapper, lowerPosition && prop('lower', s), classNameWrapper)}>
      <div className={cx(s.block, blockClassName)}>
        {/*@ts-ignore*/}
        {items.map(({ icon, text, className, customContent, block, ...handlers }, i) => (
          <div key={i} className={s.item} {...handlers}>
            <div className={cx(s.inner, { [s.innerBlock]: block })}>
              {!isNil(customContent) ? customContent : <Icon component={icon} className={cx(s.itemIcon, className)} />}

              {text && <div>{text}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditorBlockBar;
